import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import { REQUEST_SEAT_UPGRADE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { omit } from 'ui-addon-upgrades/utils';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getCorrectedUpgradeData } from '../_core/utils/getCorrectedUpgradeData';
import { getUpgradeDataTrackingProperties, mapPurchaseMotionApiName, trackPotentialBannerInteraction } from 'ui-addon-upgrades/ums/utils';
import { RequestSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { requestSeatUpgrade } from '../_core/upgrade/requestSeatUpgrade';

const UIRequestSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData,
    showModal,
    canViewNewSeats,
    onClick = () => {},
    onSuccess = () => {},
    onFailure = () => {}
  } = props;
  const upgradeDataWithApiName = Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(canViewNewSeats, upgradeData.upgradeProduct, 'UIRequestSeatButton', upgradeData.apiName)
  });
  const correctedUpgradeData = getCorrectedUpgradeData(upgradeDataWithApiName);
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'showModal', 'onClick', 'onSuccess', 'onFailure', 'usageLimitBannerData', 'canViewNewSeats');
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
  }, [correctedUpgradeData, usageLimitBannerData, level]);

  const onClickHandler = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    tracker.track('interaction', Object.assign({
      action: 'clicked request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    const {
      pointType,
      upgradeKey
    } = correctedUpgradeData;
    trackPotentialBannerInteraction(pointType, upgradeKey);

    if (!showModal) {
      onClick();
      const apiNameToUse = canViewNewSeats && upgradeData.apiName ? upgradeData.apiName : UpgradeProductToApiNameMap[correctedUpgradeData.upgradeProduct];
      requestSeatUpgrade({
        apiName: apiNameToUse
      }).then(() => onSuccess()).catch(() => onFailure());
    }
  }; // UMS Upgrade Modal does the request seat api call itself rather than opening the request seat modal


  if (!showModal) {
    return /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true
    }, propsToPass, {
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }));
  }

  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_SEAT_UPGRADE,
    upgradeData: upgradeData,
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true,
      "data-test-id": "request-seat-button"
    }, propsToPass, {
      href: getPaidUserManagementUrl(canViewNewSeats),
      target: "_blank",
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }))
  });
};

UIRequestSeatButton.defaultProps = {
  showModal: true
};
UIRequestSeatButton.propTypes = RequestSeatButtonPropsInterface;
export default UIRequestSeatButton;